import {jwtDecode} from "jwt-decode";
import Cookies from 'universal-cookie';

export default class RebatesClient {

  static isLoggedIn() {
    const token = RebatesClient.getToken();
    const isloggedin = !!token;
    
    return isloggedin;
  }

  static getTokenDecoded(){
    const token = RebatesClient.getToken();
    
    if(token){
      return jwtDecode(token);
    }
  }

  static customerName(){
    // return RebatesClient.getTokenDecoded() && RebatesClient.getTokenDecoded().customerName ? RebatesClient.getTokenDecoded().customerName : "Unknown"
    return 'Clover Farms';
  }

  static customerId(){
    return RebatesClient.getTokenDecoded() && RebatesClient.getTokenDecoded().customerId ? RebatesClient.getTokenDecoded().customerId : -1
  }

  static async standardFetch(url) {
    const headers = RebatesClient.getHeaders();
    const response = await fetch(url, { headers });

    var body;
    if (response.ok) {
      body = await response.json(); 
    }
    
    return { response, body };
  }

  

  static async updateValleyRepAssignment(data) {
    const payload = JSON.stringify(data);
    // console.log('payload', payload);

    const response = await fetch(`/api/accounts/update-rep-assignment`, {
      method: data?.action === 'assign' ? 'POST' : 'DELETE',
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };
  }

  static async updateValleyRepFarmEmailAlert(data) {
    const payload = JSON.stringify(data);
    // console.log('payload', payload);

    const response = await fetch(`/api/accounts/update-rep-farm-alert/${data.farm_account_id}`, {
      method:'POST',
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };
  }

  static async removeDealer(dealerId) {
    const response = await fetch(`/api/dealer/${dealerId}`, {
      method:'DELETE',
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };
  }

  
  
  static async saveDealer(data, dealerId) {
    const payload = JSON.stringify(data);
    // console.log('payload', payload);

    const response = await fetch(`/api/dealer${dealerId?`/${dealerId}`:''}`, {
      method: dealerId ? 'POST' : 'PUT',
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };
  }

  
  static async deleteDealerFarm(data) {
    const payload = JSON.stringify(data);
    // console.log('payload', payload);

    const response = await fetch(`/api/dealer/farm`, {
      method: 'DELETE',
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };
  }

  static async saveDealerFarms(data) {
    const payload = JSON.stringify(data);
    // console.log('payload', payload);

    const response = await fetch(`/api/dealer/farm`, {
      method: 'POST',
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };
  }

  // Strategic Accounts
  static async saveStrategicAccount(data, strategicAccountId) {
    const payload = JSON.stringify(data);
    // console.log('payload', payload);

    const response = await fetch(`/api/accounts/strategic-account${strategicAccountId?`/${strategicAccountId}`:''}`, {
      method: strategicAccountId ? 'POST' : 'PUT',
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };
  }


  static async saveRebateLevel(data, account_id) {
    const payload = JSON.stringify(data);
    // console.log('payload', payload);
    // console.log(payload)
    const response = await fetch(`/api/accounts/rebate/${account_id}`, {
      method:  'POST' ,
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };
  }


  static async saveFarmOrSubEnt(data) {
    // console.log(data)
    const payload = JSON.stringify(data);
    // console.log('payload', payload);

    const response = await fetch(`/api/accounts/farm-sub-account${data?.id?`/${data.id}`:''}`, {
      method: data?.id ? 'POST' : 'PUT',
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };
  }


  static async deleteAccount(id) {
    // console.log(data)
    // const payload = JSON.stringify(data);
    // console.log('payload', payload);

    const response = await fetch(`/api/accounts/${id}`, {
      method: 'DELETE',
      // body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };
  }


  static async saveUser(data) {
    // console.log(data)
    const payload = JSON.stringify(data);
    // console.log('payload', payload);

    const response = await fetch(`/api/user`, {
      method: data?.id ? 'POST' : 'PUT',
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };
  }

  static async sendWelcomeEmail(userId, accountId) {
    console.log(userId, accountId)
    const payload = JSON.stringify({userId, accountId});
    // console.log('payload', payload);

    const response = await fetch(`/api/user/send-welcome-email`, {
      method: 'POST' ,
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };
  }

  

  static async deleteUser(user_id, account_id, user_role) {
    const payload = JSON.stringify({user_id, account_id, user_role});
    // console.log(`delete user`, payload);
    const response = await fetch(`/api/user`, {
      method: 'DELETE',
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };

  }

  static async saveInvoiceItem(item) {
    const payload = JSON.stringify(item);
// console.log(item)
    const response = await fetch('/api/invoice/item', {
      method: item?.isNew ? 'POST': 'PUT',
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    return response
  }

  static async bulkUpdateInvoiceStatus(invoice_ids, status) {
    const payload = JSON.stringify({ invoice_ids, status });
    const response = await fetch(`/api/invoice/bulk-status`, {
      method: 'PUT',
      body: payload,
      headers: {
        'Content-Type': 'application/json'
      }
    });

    return response;
  }

  static async bulkUpdateItemEligibility(item_ids, eligibility, ineligible_reason) {
    const payload = JSON.stringify({ item_ids, eligibility, ineligible_reason });
    const response = await fetch(`/api/invoice/bulk-item-eligibility`, {
      method: 'PUT',
      body: payload,
      headers: {
        'Content-Type': 'application/json'
      }
    });

    return response;
  }

  static async updateInvoiceStatus(invoice) {
    const payload = JSON.stringify({status:invoice.status});
// console.log(payload)
    const response = await fetch(`/api/invoice/${invoice.id}`, {
      method: 'PUT',
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    return response
  }

  static async updateInvoiceDetails(invoice) {

    const payload = JSON.stringify(invoice);

    const response = await fetch(`/api/invoice/details/${invoice.invoice_id}`, {
      method: 'PUT',
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    return response
  }

  
  

  static async createInvoiceItem(item) {
    const payload = JSON.stringify(item);
// console.log(item)
    const response = await fetch('/api/invoice/item', {
      method: 'POST',
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });

    return response
  }


  static async deleteInvoiceItem(itemId) {
    const response = await fetch(`/api/invoice/item/${itemId}`, {
      method: 'DELETE',
      headers:{
        'Content-Type': 'application/json'
      }
    });

    return response

  }

  static async bulkDeleteInvoiceItems(item_ids) {
    const payload = JSON.stringify({ item_ids });
    const response = await fetch(`/api/invoice/bulk-items`, {
      method: 'DELETE',
      body: payload,
      headers: {
        'Content-Type': 'application/json'
      }
    });

    return response;
  }


  static async deleteInvoice(invoiceId) {
    const response = await fetch(`/api/invoice/${invoiceId}`, {
      method: 'DELETE',
      headers:{
        'Content-Type': 'application/json'
      }
    });

    return response

  }

  static async fetchVideos() {
    console.log('trying to load videos..');
    const response = await fetch('/api/image/fetch-new-videos',
      {
        method: 'GET',
        headers:{
          'Content-Type': 'application/json'
        }
      }
    );  

    console.log('response is..', response);

    const body = await response.json();

    return { response, body };
  }

  static async fetchImages() {
    console.log('trying to load images..');
    const response = await fetch('/api/image/fetch-new-images',
      {
        method: 'GET',
        headers:{
          'Content-Type': 'application/json'
        }
      }
    );

    console.log('response is..', response);

    const body = await response.json();

    return { response, body };
  }

  static async resetPassword(data) {
    // console.log('need to reset password..', data);

    const response = await fetch('/api/user-auth/reset-password', {
      method: 'POST',
      body: JSON.stringify(data),
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };  
  }

  static async forgotPassword(email) {
    const requestBody = { email };
    const response = await fetch('/api/user-auth/forgot-password', {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };  
  }

  static async login(email, password) {
    
    const requestBody = { email, password };
    const response = await fetch('/api/user-auth/login',
    {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers:{
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();

    return { response, body };  
  }

  static async refresh(token) {
    const response = await fetch('/api/user-auth/refresh',
    {
      method: 'POST',
      headers:{
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    const body = await response.json();

    return { response, body };  
  }


  static async getUploadedDoc(id, signal) {

    const headers = {'Authorization': 'Bearer ' + this.getToken()}

    try {
      const resp = await fetch(`/api/invoice/get-uploaded-document/${id}`, { headers, signal });
      if(!resp.ok){
        return
      }
      return resp

    } catch (error) {
      if (error.name === "AbortError" && signal) {
        //need to pass abort errors to the client so it can handle them
        throw new Error("Abort Error", { cause: error });
        
      } else {
        console.log(`error getting doc ${id}`)
        console.log(error)
      }
    }
    
  }



  static async getAllInvoices() {
    return this.standardFetch(`/api/invoice/all`);
  }

  static async saveStatement(snapshot) {
    const response = await fetch('/api/report/statements', {
      method: 'POST',
      body: JSON.stringify(snapshot),
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();
    return { response, body };
  }

  static async getStatements() {
    return this.standardFetch(`/api/report/statements`);
  }

  static async getStatement(statementId) {
    return this.standardFetch(`/api/report/statements/${statementId}`);
  }

  static async deleteStatement(statementId) {
    const response = await fetch(`/api/report/statements/${statementId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const body = await response.json();
    return { response, body };
  }
  static async tokenForUpload(fileExtension, md5) {
    return this.standardFetch(`/api/invoice/upload_token?fileExtension=${fileExtension}&md5=${encodeURIComponent(md5)}`);
  }

  static async getAllFarms() {
    return this.standardFetch(`/api/farms`);
  }

  static async uploadComplete(url, farm_account_id, md5) {
    const payload = JSON.stringify({url, farm_account_id, md5});

    const response = await fetch('/api/invoice', {
      method: 'POST',
      body: payload,
      headers:{
        'Content-Type': 'application/json'
      }
    });


    const body = await response.json();
    return { response, body };  
  }

  static getHeaders() {
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }

    if (RebatesClient.isLoggedIn()) {
        headers['Authorization'] = 'Bearer ' + RebatesClient.getToken()
    } else {
        // console.log("Not loogged in");
    }

    return headers;
  }

  static getToken() {
    const cookies = new Cookies();
    return cookies.get("rebates_token");
  }




}
